/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

import $ from 'jquery';

// Text for Hero
const firstHeroSlide = $('.home__hero-stack .home-hero-slider .slick-slide')
  .not('.slick-cloned')
  .first();

firstHeroSlide.find('.base__title p').each(function () {
  const text = $(this).text().trim();
  const sentences = text.match(/[^.!?]+[.!?]+/g);

  if (!sentences || sentences.length < 2) {
    return;
  }

  const firstSentence = sentences[0].trim();
  const secondSentence = sentences.slice(1).join(' ').trim();

  const formatSentence = (sentence) => {
    const words = sentence.split(/\s+/);

    if (words.length < 3) {
      return sentence;
    }

    return `${words.slice(0, 2).join(' ')}<br>${words.slice(2).join(' ')}`;
  };

  $(this).html(
    `${formatSentence(firstSentence)}<br><span class="highlight">${formatSentence(secondSentence)}</span>`
  );
});

// Highlight for Why Choose Us
$('.js-highlight-parse').each(function () {
  const $highlight = $(this).find('.highlight');

  if (!$highlight.length) {
    return;
  }

  let html = '';

  let node = $highlight[0].nextSibling;
  while (node) {
    html += node.nodeType === Node.TEXT_NODE
      ? node.textContent
      : node.outerHTML;

    const next = node.nextSibling;
    node.remove();
    node = next;
  }

  $highlight.append(html);
});


// Remove href from CTAs where no link provided
$('.cta[href^="javascript:"]').each(function () {
  const $cta = $(this);

  $cta.removeAttr('href');
});
